interface BulkOperationsToastAdapter {
  success: (message: string) => void
  warning: (message: string, detail?: string) => void
  error: (message: string) => void
  info: (message: string) => void
}

interface BulkOperationsConfirmAdapter {
  prompt: (options: {
    header: string
    message: string
    acceptLabel: string
    danger: boolean
    onAccept: () => void
    onReject?: () => void
  }) => void
}

interface BulkOperationsConfig {
  toast: BulkOperationsToastAdapter
  confirm: BulkOperationsConfirmAdapter
}

const notConfigured = (method: string) => () => {
  throw new Error(
    `useBulkOperations: ${method} adapter not configured. ` +
      `Call setBulkOperationsConfig({ toast, confirm }) during app bootstrap.`
  )
}

const createDefaults = (): BulkOperationsConfig => ({
  toast: {
    success: notConfigured('toast.success'),
    warning: notConfigured('toast.warning'),
    error: notConfigured('toast.error'),
    info: notConfigured('toast.info')
  },
  confirm: {
    prompt: notConfigured('confirm.prompt')
  }
})

let current: BulkOperationsConfig = createDefaults()

const setBulkOperationsConfig = (config: BulkOperationsConfig): void => {
  current = config
}

const getBulkOperationsConfig = (): BulkOperationsConfig => current

/** Test-only: reset to defaults so suites don't leak state across files. */
const resetBulkOperationsConfig = (): void => {
  current = createDefaults()
}

export { getBulkOperationsConfig, resetBulkOperationsConfig, setBulkOperationsConfig }
export type { BulkOperationsConfig, BulkOperationsConfirmAdapter, BulkOperationsToastAdapter }
